/**
 * SenderIdManagementService
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { RequestForm } from '../model/requestForm';
import { SenderIdRequestProcessingModel } from '../model/senderIdRequestProcessingModel';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class SenderIdReportService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param requestForm 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSenderIdReportGetAggregatorReportGet(requestForm?: RequestForm, observe?: 'body', reportProgress?: boolean): Observable<Array<SenderIdRequestProcessingModel>>;
    public apiSenderIdReportGetAggregatorReportGet(requestForm?: RequestForm, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SenderIdRequestProcessingModel>>>;
    public apiSenderIdReportGetAggregatorReportGet(requestForm?: RequestForm, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SenderIdRequestProcessingModel>>>;
    public apiSenderIdReportGetAggregatorReportGet(requestForm?: RequestForm, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (requestForm !== undefined && requestForm !== null) {
            queryParameters = queryParameters.set('requestForm', <any>requestForm);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<SenderIdRequestProcessingModel>>('get',`${this.basePath}/api/SenderIdReport/GetAggregatorReport`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param requestForm 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSenderIdReportGetRegulatorReportGet(requestForm?: RequestForm, observe?: 'body', reportProgress?: boolean): Observable<Array<SenderIdRequestProcessingModel>>;
    public apiSenderIdReportGetRegulatorReportGet(requestForm?: RequestForm, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SenderIdRequestProcessingModel>>>;
    public apiSenderIdReportGetRegulatorReportGet(requestForm?: RequestForm, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SenderIdRequestProcessingModel>>>;
    public apiSenderIdReportGetRegulatorReportGet(requestForm?: RequestForm, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (requestForm !== undefined && requestForm !== null) {
            queryParameters = queryParameters.set('requestForm', <any>requestForm);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<SenderIdRequestProcessingModel>>('get',`${this.basePath}/api/SenderIdReport/GetRegulatorReport`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param ID 
     * @param requestForm 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSenderIdReportGetReportByIdIDGet(ID: string, requestForm?: RequestForm, observe?: 'body', reportProgress?: boolean): Observable<SenderIdRequestProcessingModel>;
    public apiSenderIdReportGetReportByIdIDGet(ID: string, requestForm?: RequestForm, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SenderIdRequestProcessingModel>>;
    public apiSenderIdReportGetReportByIdIDGet(ID: string, requestForm?: RequestForm, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SenderIdRequestProcessingModel>>;
    public apiSenderIdReportGetReportByIdIDGet(ID: string, requestForm?: RequestForm, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (ID === null || ID === undefined) {
            throw new Error('Required parameter ID was null or undefined when calling apiSenderIdReportGetReportByIdIDGet.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (requestForm !== undefined && requestForm !== null) {
            queryParameters = queryParameters.set('requestForm', <any>requestForm);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SenderIdRequestProcessingModel>('get',`${this.basePath}/api/SenderIdReport/GetReportById/${encodeURIComponent(String(ID))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param spID 
     * @param requestForm 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSenderIdReportGetServiceProviderReportSpIDGet(spID: string, requestForm?: RequestForm, observe?: 'body', reportProgress?: boolean): Observable<Array<SenderIdRequestProcessingModel>>;
    public apiSenderIdReportGetServiceProviderReportSpIDGet(spID: string, requestForm?: RequestForm, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SenderIdRequestProcessingModel>>>;
    public apiSenderIdReportGetServiceProviderReportSpIDGet(spID: string, requestForm?: RequestForm, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SenderIdRequestProcessingModel>>>;
    public apiSenderIdReportGetServiceProviderReportSpIDGet(spID: string, requestForm?: RequestForm, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (spID === null || spID === undefined) {
            throw new Error('Required parameter spID was null or undefined when calling apiSenderIdReportGetServiceProviderReportSpIDGet.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (requestForm !== undefined && requestForm !== null) {
            queryParameters = queryParameters.set('requestForm', <any>requestForm);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<SenderIdRequestProcessingModel>>('get',`${this.basePath}/api/SenderIdReport/GetServiceProviderReport/${encodeURIComponent(String(spID))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param telco 
     * @param requestForm 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSenderIdReportGetTelcoReportTelcoGet(telco: string, requestForm?: RequestForm, observe?: 'body', reportProgress?: boolean): Observable<Array<SenderIdRequestProcessingModel>>;
    public apiSenderIdReportGetTelcoReportTelcoGet(telco: string, requestForm?: RequestForm, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SenderIdRequestProcessingModel>>>;
    public apiSenderIdReportGetTelcoReportTelcoGet(telco: string, requestForm?: RequestForm, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SenderIdRequestProcessingModel>>>;
    public apiSenderIdReportGetTelcoReportTelcoGet(telco: string, requestForm?: RequestForm, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (telco === null || telco === undefined) {
            throw new Error('Required parameter telco was null or undefined when calling apiSenderIdReportGetTelcoReportTelcoGet.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (requestForm !== undefined && requestForm !== null) {
            queryParameters = queryParameters.set('requestForm', <any>requestForm);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<SenderIdRequestProcessingModel>>('get',`${this.basePath}/api/SenderIdReport/GetTelcoReport/${encodeURIComponent(String(telco))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
